<template>
    <div style="display:grid; min-height:100vh;">
        <!-- <loading
          :active.sync="isLoading"
          :can-cancel="false"
          loader="dots"
          :is-full-page="fullPage"
          :height="height"
          :width="width"
          background-color="#6b6969"
        ></loading>-->

        <div class="page-register h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
            <div class="container">
                <div class="row" style="display: flex; background: white">
                    <div class="col-md-6 register-right d-none d-sm-block">
                        <div class="custom-container centered">
                            <div class="card inner-card">
                                <div class="card-body text-light">
                                    <h2>LOGO</h2>
                                    <div class="divider"></div>

                                    <h3>Join our network</h3>
                                    <p>of influencial and entrepreneur ladies</p>
                                    <p id="have-account">Already have an account?</p>
                                    <p class="text-orange">Sign in</p>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-8 offset-md-2">
                                <form class="form-item">
                                    <h2 class="text-green font-weight-bold mb-5">Register</h2>

                                    <div class="form-group">
                                        <label for="full_name">Full name</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-user"></i>
                    </span>
                                            </div>
                                            <input type="text" id="full_name" class="form-control border-left-0"
                                                   placeholder="eg. James Arthur">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="email">Email</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-envelope"></i>
                    </span>
                                            </div>
                                            <input type="text" id="email" class="form-control border-left-0"
                                                   placeholder="eg. Jamesarthur@gmail.com">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Password</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-lock"></i>
                    </span>
                                            </div>
                                            <input type="password" class="form-control border-left-0 border-right-0"
                                                   placeholder="eg. James Arthur">
                                            <div class="input-group-append">
                                                <span class="input-group-text border-right border-left-0"><i
                                                    class="material-icons text-muted" style="font-size: 17px">visibility_off</i></span>
                                            </div>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="">
                                        <button @click="$router.push('/')" type="submit"
                                                class="btn btn-orange btn-block">Login
                                        </button>
                                    </div>
                                    <!--<div class="col-md-12 mt-3">-->
                                    <!--<a href="/reset-password" class="text-red pull-left">Reset-->
                                    <!--Password?</a><a href="/sign-up" class="text-green pull-right">No account,-->
                                    <!--sign up-->
                                    <!--here? </a></div>-->
                                    <!--<br>-->
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>


<script>
    /* eslint-disable */
    // import Swal from "sweetalert2";
    import navbar from "../components/navbar";
    import downFooter from "../components/footer";
    // import Loading from "vue-loading-overlay";
    // import "vue-loading-overlay/dist/vue-loading.css";
    // import axios from "axios";

    // import $ from "jquery";

    export default {
        data() {
            return {
                isLoading: false,
                fullPage: true,
                details: {},
                height: 128,
                width: 128
            };
        },
        components: {
            // Loading,
            downFooter,
            navbar
        },
        methods: {},
        mounted: function () {
            const player = new Plyr("#player", {
                title: "hello"
                // debug:true,
                // duration:1,
            });
        },
        created() {
        }
    };
</script>

<style scoped>
    .divider {
        width: 100px;
        background: #F26526;
        height: 3px;
        border-radius: 5px;
    }

    .custom-container {
        width: 100%;
        padding-right: 3rem;
        padding-left: 3rem;
        margin-right: auto;
        margin-left: auto;
    }

    .page-register {
        background-image: url('../../public/assets/img/register-back.jpg');
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .items-center {
        align-items: center !important;
    }

    .h-screen {
        height: 100vh !important;
    }

    .vx-row {
        display: flex;
        flex-wrap: wrap;
    }

    .form-item {
        margin: 8rem 0 12rem 0px;
    }

    #have-account {
        margin-top: 15rem;
    }

    .register-right {
        background-image: url('../../public/assets/img/back-1.png');
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: right;
    }

    .inner-card {
        background-image: url('../../public/assets/img/back-2.png');
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: right;
    }


    @media screen and (min-width: 200px) and (max-width: 410px) {

    }

    @media screen and (min-width: 411px) and (max-width: 823px) {

    }

    /*.form-control{*/
    /*border: 1px solid #ccc;*/
    /*}*/

    label {
        color: #000;
    }

    .form-control {
        background: none;

        display: block;
        width: 100%;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #212529;
        /*background-color: #fff;*/
        background-clip: padding-box;
        border: 1px solid #ced4da;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    span i {
        color: #0000004d !important;
    }

    .input-group {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        width: 100%;
    }

    .input-group > .form-control,
    .input-group > .form-select {
        position: relative;
        flex: 1 1 auto;
        width: 1%;
        min-width: 0;
    }

    .input-group > .form-control:focus,
    .input-group > .form-select:focus {
        z-index: 3;
    }

    .input-group .btn {
        position: relative;
        z-index: 2;
    }

    .input-group .btn:focus {
        z-index: 3;
    }

    .input-group-text {
        display: flex;
        align-items: center;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #212529;
        text-align: center;
        white-space: nowrap;
        /*background-color: #e9ecef;*/
        border-left: 1px solid #ced4da;
        border-top: 1px solid #ced4da;
        border-bottom: 1px solid #ced4da;
        border-right: 0px;

        border-radius: 0.25rem;
    }

    .input-group-lg > .form-control,
    .input-group-lg > .form-select,
    .input-group-lg > .input-group-text,
    .input-group-lg > .btn {
        padding: 0.5rem 1rem;
        font-size: 1.25rem;
        border-radius: 0.3rem;
    }

    .input-group-sm > .form-control,
    .input-group-sm > .form-select,
    .input-group-sm > .input-group-text,
    .input-group-sm > .btn {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        border-radius: 0.2rem;
    }

    .input-group-lg > .form-select,
    .input-group-sm > .form-select {
        padding-right: 3rem;
    }

    .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),
    .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),
    .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
        margin-left: -1px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }


    .centered {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

</style>